var map = {
	"./ic_32_sport_american_football-active.svg": "a53b",
	"./ic_32_sport_american_football-white.svg": "431d",
	"./ic_32_sport_american_football.svg": "9e4b",
	"./ic_32_sport_basketball-active.svg": "afe1",
	"./ic_32_sport_basketball-white.svg": "0d29",
	"./ic_32_sport_basketball.svg": "bfbb",
	"./ic_32_sport_eishockey-active.svg": "b6c5",
	"./ic_32_sport_eishockey-white.svg": "8747",
	"./ic_32_sport_eishockey.svg": "c9a1",
	"./ic_32_sport_fussball-active.svg": "d3d6",
	"./ic_32_sport_fussball-white.svg": "6161",
	"./ic_32_sport_fussball.svg": "994e",
	"./ic_32_sport_handball-active.svg": "929f",
	"./ic_32_sport_handball-white.svg": "885d",
	"./ic_32_sport_handball.svg": "65b0",
	"./ic_32_sport_hockey-active.svg": "45a9",
	"./ic_32_sport_hockey-white.svg": "2a2c",
	"./ic_32_sport_hockey.svg": "9361",
	"./ic_32_sport_tennis-active.svg": "4422",
	"./ic_32_sport_tennis-white.svg": "3369",
	"./ic_32_sport_tennis.svg": "6f8f",
	"./ic_32_sport_tischtennis-active.svg": "018b",
	"./ic_32_sport_tischtennis-white.svg": "fbe7",
	"./ic_32_sport_tischtennis.svg": "a224",
	"./ic_32_sport_volleyball-active.svg": "4cbb",
	"./ic_32_sport_volleyball-white.svg": "7936",
	"./ic_32_sport_volleyball.svg": "2ffa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db4a";